import { ArrowUpRight, MousePointer2 } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { trackAffiliateClick } from "@/lib/analytics";
import { registerClick } from "@/lib/clicks";
import { analytics } from "@heycatch/sdk";

const TRAFFICADBAR_URL = "https://trafficadbar.com/geoffc111";

const PartnerOffer = () => (
  <section className="pb-20 sm:pb-28 bg-white" data-testid="partner-offer-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <div className="rounded-3xl border border-zinc-200 bg-[#FAF8F5] p-8 sm:p-10 flex flex-col md:flex-row md:items-center gap-6 md:gap-10">
          <div className="grid place-items-center w-12 h-12 rounded-2xl bg-zinc-900 text-amber-400 shrink-0">
            <MousePointer2 className="w-6 h-6" />
          </div>
          <div className="flex-1">
            <p className="text-[11px] font-bold uppercase tracking-widest text-zinc-500">
              Partner recommendation — we earn a commission if you join
            </p>
            <h2 className="mt-2 font-display text-xl sm:text-2xl font-extrabold tracking-tight text-zinc-900">
              Have your own site or offer? Get free traffic for it
            </h2>
            <p className="mt-2 text-sm sm:text-base text-zinc-600 leading-relaxed max-w-2xl">
              TrafficAdBar is a free traffic exchange: you browse other members' sites, and they see
              yours in return. A simple way to put any link — including your own Honeygain referral
              page — in front of thousands of people without paying for ads.
            </p>
          </div>
          <a
            href={TRAFFICADBAR_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="partner-offer-join-button"
            onClick={() => {
              trackAffiliateClick("trafficadbar_card");
              analytics.trackEvent("partner_offer_click", { offer: "trafficadbar" });
              registerClick("trafficadbar");
            }}
            className="group inline-flex items-center justify-center gap-2 rounded-full border-2 border-zinc-900 px-6 py-3.5 font-display text-sm font-bold text-zinc-900 hover:bg-zinc-900 hover:text-white transition-colors whitespace-nowrap"
          >
            Get Free Traffic
            <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);

export default PartnerOffer;
